import * as React from 'react'

import { TBgColorKey, TStatusColorKeyOrGrey } from '~theme/typings'
import { Flex } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TContainerProps = Pick<PropsOf<typeof Flex>, 'gap' | 'radius' | 'padding'>

type TProps = RequiredChildren &
  TContainerProps & {
    bgColor?: TStatusColorKeyOrGrey
    noBorder?: boolean
    textAlign?: PropsOf<typeof Flex>['textAlign']
  }

/**
 * styled message container with status bg color and a border,
 * use for cases when some message should be highlighted
 */
export const MessageBox: React.FC<TProps> = ({
  bgColor = 'grey',
  children,
  gap,
  radius = `small`,
  noBorder = false,
  padding = { vertical: `smallMedium`, horizontal: `medium` },
  textAlign = `center`,
}) => {
  const bgColorKey: TBgColorKey = bgColor === 'grey' ? 'messages' : bgColor

  return (
    <Flex
      gap={gap}
      radius={radius}
      padding={padding}
      alignItems={`center`}
      textAlign={textAlign}
      flexDirection={`column`}
      justifyContent={`center`}
      bgColor={`bgColors.${bgColorKey}`}
      border={noBorder ? `unset` : `1px solid hsla(0, 0%, 0%, 0.2)`}
    >
      {children}
    </Flex>
  )
}

type TMessageBoxTextProps = RequiredChildren & PropsOf<typeof Text>

/**
 * text that should be used only inside MessageBox as a default,
 * sets common styles & props
 */
export const MessageBoxText: React.FC<TMessageBoxTextProps> = ({ children, ...textProps }) => {
  return <Text {...textProps}>{children}</Text>
}
